import {
  DataRoomRFI,
  RFI_ACTIVITY_TAB,
  RfiActivityTab,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { RfiActivityAccessDate } from 'router/subrouters/DataRoom/models/DataRoomMember';
import { getLatestDate, isEarlierDate } from 'dateUtils';
import { getHasElementsInArray } from 'utils';

const VIEWED_AT_FIELD_BY_TAB: Record<
  RfiActivityTab,
  keyof RfiActivityAccessDate
> = {
  [RFI_ACTIVITY_TAB.MESSAGES]: 'lastMessagesViewedAt',
  [RFI_ACTIVITY_TAB.ADDITIONAL_FILES]: 'lastAdditionalFilesViewedAt',
};

export const getRfiActivityAccessDate = (
  accessDates: RfiActivityAccessDate[] = [],
  dataRoomRfiId: string,
) =>
  accessDates.find((accessDate) => accessDate.dataRoomRfiId === dataRoomRfiId);

export const getHasUnreadMessages = (rfi: DataRoomRFI, lastViewedAt?: Date) => {
  const dates = (rfi?.brokerMessages || []).map(({ addedAt }) => addedAt);

  return (
    getHasElementsInArray(dates) &&
    isEarlierDate(lastViewedAt, new Date(getLatestDate(dates)))
  );
};

export const getHasUnreadAdditionalFiles = (
  rfi: DataRoomRFI,
  lastViewedAt?: Date,
) => {
  const dates = (rfi?.additionalDocumentsCategory?.files || []).map(
    ({ createdAt }) => createdAt,
  );

  return (
    getHasElementsInArray(dates) &&
    isEarlierDate(lastViewedAt, new Date(getLatestDate(dates)))
  );
};

export const getHasUnreadActivity = (
  rfi: DataRoomRFI,
  accessDate?: RfiActivityAccessDate,
) =>
  getHasUnreadMessages(rfi, accessDate?.lastMessagesViewedAt) ||
  getHasUnreadAdditionalFiles(rfi, accessDate?.lastAdditionalFilesViewedAt);

export const upsertRfiActivityAccessDate = (
  accessDates: RfiActivityAccessDate[] = [],
  dataRoomRfiId: string,
  tab: RfiActivityTab,
): RfiActivityAccessDate[] => {
  const viewedAtField = VIEWED_AT_FIELD_BY_TAB[tab];

  const existing = getRfiActivityAccessDate(accessDates, dataRoomRfiId);

  const updated = {
    ...existing,
    dataRoomRfiId,
    [viewedAtField]: new Date(),
  };

  return existing
    ? accessDates.map((accessDate) =>
        accessDate.dataRoomRfiId === dataRoomRfiId ? updated : accessDate,
      )
    : [...accessDates, updated];
};
